export type HomeLeftAction = {
	type: 'HOME_LEFT';
};

export default (): HomeLeftAction => ({
	type: 'HOME_LEFT',
});
